"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const BulkDownloader_vue_1 = __importDefault(require("./BulkDownloader.vue"));
let FastBulkDownload = class FastBulkDownload extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.selectedLocations = [];
        this.selectedTreatments = [];
        this.selectedTimes = [];
        this.samplesInvolved = [];
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get locations() {
        let myLocations = this.configuration.locations.map((loc) => loc);
        /*         myLocations.unshift(new LocationConfiguration({
                    name: 'All',
                    label: 'All',
                    id: 0,
                    crop: '',
                    hook: 'all',
                    treatments: []
                })) */
        return myLocations;
    }
    get treatments() {
        return this.configuration.treatments;
    }
    get times() {
        return this.configuration.times;
    }
    updateSamplesInvolved() {
        let locIx = [];
        if (this.selectedLocations.length === 0) {
            this.locations.forEach((l, i) => {
                locIx.push(i);
            });
        }
        else {
            for (let loc of this.selectedLocations) {
                const myLocIx = this.locations.findIndex((l) => l.id === loc.id);
                locIx.push(myLocIx);
            }
        }
        let treatIx = [];
        if (this.selectedTreatments.length === 0) {
            this.treatments.forEach((tr, j) => {
                treatIx.push(j);
            });
        }
        else {
            for (let tr of this.selectedTreatments) {
                const myTreatIx = this.treatments.findIndex((t) => t.name === tr.name);
                treatIx.push(myTreatIx);
            }
        }
        let timeIx = [];
        if (this.selectedTimes.length === 0) {
            this.times.forEach((tr, k) => {
                timeIx.push(k);
            });
        }
        else {
            for (let ti of this.selectedTimes) {
                const myTimeIx = this.times.findIndex((t) => t.time === ti.time);
                timeIx.push(myTimeIx);
            }
        }
        this.samplesInvolved = this.configuration.samplesInsideCustomBulk(locIx, treatIx, timeIx);
    }
    updateLocationsSelected(model) {
        this.selectedLocations = model;
        this.updateSamplesInvolved();
    }
    updateTreatmentsSelected(model) {
        this.selectedTreatments = model;
        this.updateSamplesInvolved();
    }
    updateTimesSelected(model) {
        this.selectedTimes = model;
        this.updateSamplesInvolved();
    }
    mounted() {
        this.updateSamplesInvolved();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], FastBulkDownload.prototype, "configuration", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], FastBulkDownload.prototype, "theme", void 0);
FastBulkDownload = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            PlusIcon: bmk_ui_framework_1.PlusIcon,
            SelectField: bmk_ui_framework_1.SelectField,
            Select: bmk_ui_framework_1.Select,
            Button: bmk_ui_framework_1.Button,
            BulkDownloader: BulkDownloader_vue_1.default
        },
    })
], FastBulkDownload);
exports.default = FastBulkDownload;
